import { request } from '../../lib/api.js'
export const calendarCall = (action, body, signal) => request(`/api/rep/calendar/${action}`, {
  ...(body === undefined ? {} : { method: 'POST', body, audit: { redact: true } }), signal,
})
export function calendarStatusText(state) {
  if (!state) return 'Checking calendar connection…'
  if (!state.enabled) return 'Automatic sync is awaiting setup. Monthly export is available.'
  const labels = { disconnected: 'Google Calendar is disconnected.', connected: 'Google Calendar is connected.', retrying: 'Sync was interrupted. It will retry automatically.', reconnect_required: 'Reconnect Google Calendar to resume updates.', creation_uncertain: 'Calendar setup needs administrator review before retrying.', attention_required: 'Calendar sync needs attention. Your last successful sync is shown below.' }
  return labels[state.status] || 'Calendar status is unavailable.'
}
export function downloadCalendar(ics, month, browser = window) {
  const url = browser.URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }))
  const anchor = browser.document.createElement('a')
  anchor.href = url; anchor.download = `sr-championships-${month}.ics`
  browser.document.body.appendChild(anchor); anchor.click(); anchor.remove()
  browser.setTimeout(() => browser.URL.revokeObjectURL(url), 1000)
}
